import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { EventEmitterService } from '../services/event-emitter.service';

declare var $: any;

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {

  @ViewChild('showButton') showButton: ElementRef;
  @ViewChild('hideButton') hideButton: ElementRef;

  constructor(
    public auth: AuthService,
    private eventEmitterService: EventEmitterService
    ) { }

  hide(){
    this.hideButton.nativeElement.click();
  };

  show(){
    this.showButton.nativeElement.click();
  };
  
  ngOnInit(): void {
    if (this.eventEmitterService.subShowLoginModal==undefined) {    
      this.eventEmitterService.subShowLoginModal = this.eventEmitterService.
      showLoginModal.subscribe((show:boolean) => {   
        if(show){
          this.show(); 
        }else{
          this.hide();
        }
      });    
    }    
  }

}
